import { Pagination } from '@th-types/pageable.type';

/** Explicit page size for webapp direct-chat thread loads (do not rely on BE default 1000). */
export const DIRECT_CHAT_MESSAGE_PAGE_SIZE = 50;

/**
 * Compat rule: missing pagination means a full list — never assume truncation.
 * When present, older pages remain if this page does not reach the total count.
 */
export function hasMoreOlderMessages(
  pagination: Pagination | null | undefined,
  pageMessageCount: number
): boolean {
  if (!pagination) return false;
  return pagination.offset + pageMessageCount < pagination.count;
}

export function nextOlderMessagesOffset(
  pagination: Pagination | null | undefined
): number | null {
  if (!pagination) return null;
  return pagination.offset + pagination.max;
}
